module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Calanca_COA-1e58fa5eda8cb308a1c3ddcf3767579d.svg";